/* eslint-env browser */
import * as React from 'react'

import withTranslator from '../../../client/clientjs/components/TranslatorProvider'

require('../../../container/client')

const ReactDOM = require('react-dom')
const PropTypes = require('prop-types')

const DomHelper = require('../../../client/clientjs/dom-helper')
const ShareModal = require('../../../client/clientjs/components/Modals/ShareModal')

class ShareModalContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalVisible: false,
    }
    this.onClickShare = this.onClickShare.bind(this)
    this.onHide = this.onHide.bind(this)
  }

  onClickShare() {
    this.setState({ isModalVisible: true })
  }

  onHide() {
    this.setState({ isModalVisible: false })
  }

  render() {
    const { isModalVisible } = this.state
    const { translate } = this.props
    return (
      <>
        <button className="button is-white is-large" type="button" onClick={this.onClickShare}>
          <span className="icon has-text-ctaGreen">
            <i className="fas fa-share" />
          </span>
          <span className="has-text-primary-blue has-text-weight-bold">{translate('share')}</span>
        </button>
        <ShareModal
          isActive={isModalVisible}
          host={window.location.origin}
          shareableLink={window.location.pathname}
          onHide={this.onHide}
        />
      </>
    )
  }
}
ShareModalContainer.propTypes = {
  locale: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
}

const ShareModalContainerWithTranslator = withTranslator(ShareModalContainer)

DomHelper.onDocumentReady(() => {
  const renderElt = DomHelper.query('#react-render-share-button')
  if (renderElt) {
    ReactDOM.render(<ShareModalContainerWithTranslator locale={window.initialState.locale.identifier} />, renderElt)
  }
  const renderElt2 = DomHelper.query('#react-render-share-button-2')
  if (renderElt2) {
    ReactDOM.render(<ShareModalContainerWithTranslator locale={window.initialState.locale.identifier} />, renderElt2)
  }
})

if (module.hot) {
  module.hot.accept()
}
